import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import useScrollToHash from '@hooks/useScrollToHash';
import { getImgixSrc } from '@utils/images';

import { PAST_PARTNERS_LOGOS } from './constant';

const Patners = () => {
  const partnersRef = useScrollToHash({ hash: '#partner-section', offset: 100 });
  return (
    <article className="px-12 pb-80" id="partner-section" ref={partnersRef}>
      <div className="m-auto max-w-container-lg">
        <h2 className="mb-32 text-center text-overline-md font-normal text-black">Past Partners</h2>
        <div className="flex flex-wrap items-center justify-around gap-x-32 gap-y-16 sm:gap-x-32 sm:gap-y-24">
          {PAST_PARTNERS_LOGOS.map(({ path, alt }) => (
            <div
              key={path}
              className="flex h-[88px] w-[150px] max-w-full shrink-0 items-center justify-center sm:h-[100px]"
            >
              <LazyImgixImage
                src={getImgixSrc({
                  path,
                  isEnvDependent: false,
                })}
                alt={alt}
                className="max-h-full w-auto max-w-full object-contain object-center"
                wrapperClassName="flex max-h-full w-full items-center justify-center"
              />
            </div>
          ))}
        </div>
      </div>
    </article>
  );
};

export default Patners;
